import { useEffect, useState, useContext } from 'react';
import { BreakdownsContext } from './contexts/BreakdownsContext';
import { BreakdownsContextType } from './contexts/BreakdownsContextTypes';
import {
  platformIconsMapping,
} from '../../../utils/platforms';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { Link } from 'react-router-dom';
import { BreakdownsContainer } from '../../../components/BreakdownsContainer/BreakdownsContainer';
import { ReactComponent as VerifiedTwitter } from '../../SourcePage/assets/verifiedTwitter.svg';
import { LoaderSmall } from '../../../components/LoaderSmall/LoaderSmall';
import { mapCompromisedEntityTypes } from '../../../utils/actors';
import { cutString } from '../../../utils/cutString';
import { decodeSourceName } from '../../../utils/decodeURI';
import { useTranslation } from 'react-i18next';
import styles from '../NarrativePage.module.scss';

interface TopHighRiskProps {
  isClickable?: boolean;
  isShare?: boolean;
}

export const TopHighRisk: React.FC<TopHighRiskProps> = ({ isShare, isClickable = true }) => {
  const { t } = useTranslation();
  const [topHighRisk, setTopHighRisk] = useState<any | null>(null);
  const compromisedEntityTypes = mapCompromisedEntityTypes(t);

  const {
    highRisk,
  } = useContext(BreakdownsContext) as BreakdownsContextType;

  useEffect(() => {
    if (!highRisk) return;
    setTopHighRisk(highRisk.top_actors || []);
  }, [highRisk]);

  return (
    <BreakdownsContainer
      title={t('Top high risk accounts')}
      details={false}
      flexGrow={1}
    >
      {highRisk ? (
        topHighRisk?.length > 0 ? (
          <div className={styles.breakdownsListMain}>
            {topHighRisk.map((source: any, index: any) => {
              return (
                <div key={`highrisk_${index}`} className={styles.listItem}>
                  <div className={styles.info}>
                    <span>{platformIconsMapping[source?.platform]}</span>
                    <span className={styles.title}>
                      {isShare || !isClickable ? (
                        <Tooltip content={source.name} position="bottom">
                          {cutString(decodeSourceName(source.name), 30)}
                        </Tooltip>
                      ) : (
                        <Link to={`/sources/${source.id}`}>
                          <Tooltip content={source.name} position="bottom">
                            {cutString(decodeSourceName(source.name), 30)}
                          </Tooltip>
                          {source?.is_verified ? (
                            <span className={styles.verified}>
                              <VerifiedTwitter />
                            </span>
                          ) : (
                            ''
                          )}
                        </Link>
                      )}
                    </span>
                  </div>
                  <div className={styles.details}>{compromisedEntityTypes[source?.risk_type as keyof typeof compromisedEntityTypes]?.title || ''}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.noDataBreakdowns}>
            {t('There is no data to display')}
          </div>
        )
      ) : (
        <div className={styles.widgetLoader}>
          <LoaderSmall />
        </div>
      )}
    </BreakdownsContainer>
  );
};
